import { formatAbsolute, formatRelative, relativeRefreshMs } from '../lib/format.ts';
import { cn } from '../lib/cn.ts';
import { useNow } from '../lib/useNow.ts';
import { Tooltip } from './Tooltip.tsx';

export interface RelativeTimeProps {
  ts: number | null | undefined;
  /** Prefix such as "Updated". */
  prefix?: string;
  /** Shown when ts is missing. */
  fallback?: string;
  className?: string;
}

/** "4 min ago", updating live (one shared clock), with the absolute time on hover. */
export function RelativeTime({ ts, prefix, fallback = 'Never', className }: RelativeTimeProps) {
  const now = useNow(ts == null ? 60_000 : relativeRefreshMs(ts));
  if (ts == null || !Number.isFinite(ts)) return <span className={cn('text-fg-subtle', className)}>{fallback}</span>;
  const text = formatRelative(ts, now);
  return (
    <Tooltip content={formatAbsolute(ts)} delay={400}>
      <time dateTime={new Date(ts).toISOString()} tabIndex={-1} className={cn('whitespace-nowrap num', className)}>
        {prefix ? `${prefix} ${text}` : text}
      </time>
    </Tooltip>
  );
}
